import React, { Children } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const Features = () => {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="caracteristicas" className="py-20 md:py-32 bg-white overflow-hidden" data-id="element-91">
      <div className="container mx-auto px-4" data-id="element-92">
        <div className="max-w-3xl mx-auto" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} data-id="element-94">
            <h2 className="text-3xl md:text-5xl font-bold text-benefika-charcoal mb-6 leading-tight" data-id="element-95">
              ¿Por qué elegir{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-benefika-teal to-benefika-emerald" data-id="element-96">
                Benefika
              </span>
              ?
            </h2>
            <p className="text-lg text-benefika-gray mb-10 leading-relaxed" data-id="element-97">
              Como parte del ecosistema de TicketMaestro, combinamos tecnología
              robusta con un profundo entendimiento del comportamiento del
              consumidor para crear programas de beneficios que realmente
              importan.
            </p>

            <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="space-y-6" data-id="element-98">
              <motion.div variants={itemVariants} className="flex items-start" data-id="element-99">
                <div className="mt-1 bg-benefika-teal/10 p-1 rounded-full mr-4 flex-shrink-0" data-id="element-100">
                  <CheckCircle2 className="text-benefika-teal w-6 h-6" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="font-bold text-benefika-charcoal text-xl mb-1" data-id="element-103">
                    Especialización exclusiva
                  </h3>
                  <p className="text-benefika-gray leading-relaxed" data-id="element-104">
                    Nos dedicamos 100% a la fidelización. Respiramos lealtad y
                    retención de clientes todos los días.
                  </p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start" data-id="element-105">
                <div className="mt-1 bg-benefika-amber/10 p-1 rounded-full mr-4 flex-shrink-0" data-id="element-106">
                  <CheckCircle2 className="text-benefika-amber w-6 h-6" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <h3 className="font-bold text-benefika-charcoal text-xl mb-1" data-id="element-109">
                    Red de aliados estratégicos
                  </h3>
                  <p className="text-benefika-gray leading-relaxed" data-id="element-110">
                    Contamos con un catálogo extenso de comercios y marcas
                    aliadas listas para integrarse a su programa.
                  </p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start" data-id="element-111">
                <div className="mt-1 bg-benefika-emerald/10 p-1 rounded-full mr-4 flex-shrink-0" data-id="element-112">
                  <CheckCircle2 className="text-benefika-emerald w-6 h-6" data-id="element-113" />
                </div>
                <div data-id="element-114">
                  <h3 className="font-bold text-benefika-charcoal text-xl mb-1" data-id="element-115">
                    Tecnología escalable
                  </h3>
                  <p className="text-benefika-gray leading-relaxed" data-id="element-116">
                    Plataformas seguras, rápidas y adaptables que crecen al
                    mismo ritmo que su base de clientes.
                  </p>
                </div>
              </motion.div>

              <motion.div variants={itemVariants} className="flex items-start" data-id="element-117">
                <div className="mt-1 bg-benefika-gold/10 p-1 rounded-full mr-4 flex-shrink-0" data-id="element-118">
                  <CheckCircle2 className="text-benefika-gold w-6 h-6" data-id="element-119" />
                </div>
                <div data-id="element-120">
                  <h3 className="font-bold text-benefika-charcoal text-xl mb-1" data-id="element-121">
                    Respaldo TicketMaestro
                  </h3>
                  <p className="text-benefika-gray leading-relaxed" data-id="element-122">
                    La solidez y experiencia de una empresa líder en
                    transacciones y gestión de grandes volúmenes de usuarios.
                  </p>
                </div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default Features;